import { Typography, Row, Col, Button } from 'antd';
import { QRCodeCanvas } from 'qrcode.react'; // Import QRCodeCanvas
import '../styles/Cultos.css';
import { FaGoogleDrive } from 'react-icons/fa';

const { Title } = Typography;

const Cultos = ({ title, description, qrUrl, buttonText }) => {
  return (
    <div
      id="cultos"
      style={{
        textAlign: 'center',
        padding: '20px',
        marginTop: '40px',
        marginBottom: '40px',
      }}
    >
      <Row justify="center" align="middle" gutter={[16, 16]}>
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={6}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end', // Align content to the bottom
            textAlign: 'center', // Optional: Align text to the left
          }}
        >
          <Title level={2} style={{ fontFamily: 'Outfit', fontSize: '40px' }}>
            {title}
          </Title>
          <p
            style={{
              fontSize: '20px',
              display: 'block',
              marginTop: '10px',
              fontFamily: 'Roboto',
            }}
          >
            {description}
          </p>

          <Row justify="center">
            <Button
              icon={<FaGoogleDrive />}
              type="primary"
              size="large"
              className="cultos-button"
              href={qrUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {buttonText}
            </Button>
          </Row>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={6}
          style={{
            display: 'flex',
            justifyContent: 'center', // Center horizontally
            alignItems: 'center', // Center vertically
          }}
        >
          <div className="qr-container">
            <div className="qr-wrapper">
              <QRCodeCanvas
                value={qrUrl} // URL to redirect
                bgColor="#ffffff" // Background color
                fgColor="#000000" // Foreground color
                size={300}
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Cultos;
